export default __webpack_public_path__ + "static/media/cont9.d6a2af9d.jpeg";